import * as React from 'react';
const EyeIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.267 10.6a13 13 0 0 1-.364-.6 13.2 13.2 0 0 1 1.8-2.445c1.265-1.35 3.058-2.63 5.297-2.63 2.24 0 4.032 1.28 5.297 2.63a13.2 13.2 0 0 1 1.8 2.445 13.2 13.2 0 0 1-1.8 2.445c-1.265 1.35-3.058 2.63-5.297 2.63-2.24 0-4.032-1.28-5.297-2.63A13 13 0 0 1 3.267 10.6m14.845-.824-.447.224.447.224v.002l-.003.004-.008.015a5 5 0 0 1-.13.24 14.2 14.2 0 0 1-1.945 2.645c-1.348 1.438-3.387 2.945-6.026 2.945s-4.678-1.507-6.026-2.946a14.2 14.2 0 0 1-1.945-2.644 8 8 0 0 1-.13-.24l-.008-.015-.002-.004v-.002h-.001L2.335 10l-.447-.224v-.002l.003-.004.007-.015a5 5 0 0 1 .13-.24A14.2 14.2 0 0 1 3.974 6.87C5.324 5.433 7.362 3.926 10 3.926s4.678 1.507 6.026 2.946a14.2 14.2 0 0 1 1.945 2.644q.069.121.103.188l.015.028.013.024.007.015zM2.335 10l-.447.224a.5.5 0 0 1 0-.448zm15.33 0 .447-.224a.5.5 0 0 1 0 .448zM8.41 10a1.59 1.59 0 1 1 3.18 0 1.59 1.59 0 0 1-3.18 0M10 7.41a2.59 2.59 0 1 0 0 5.18 2.59 2.59 0 0 0 0-5.18"
      fill="currentColor"
    />
  </svg>
);
export default EyeIcon;
